



















































import Vue from 'vue'
import { getPathsForMany } from '@/components/data/common/helpers'

export default Vue.extend({
  name: 'MixGraph',
  props: {
    graphHeight: Number,
    columnWidth: Number,
    strokeWidth: Number,
    circleRadius: Number,
    offsetWidth: Number,
    offsetHeight: Number,
    mainColor: String,
    pathColor: String,
    firstDataset: Array,
    secondDataset: Array,
    width: String,
    maxWidth: String,
    bottom: String,
    min: Number,
    max: Number
  },
  data: () => ({
    paths: []
  }),
  computed: {
    graphWidth () {
      // Same width for each dataset
      return this.columnWidth * this.firstDataset.length
    }
  },
  methods: {
    buildLine () {
      this.paths =
        getPathsForMany(
          this.graphHeight,
          this.firstDataset,
          this.secondDataset,
          this.columnWidth,
          this.circleRadius,
          this.min,
          this.max
        )
    }
  },
  watch: {
    graphWidth () {
      this.buildLine()
    },
    firstDataset: {
      deep: true,
      immediate: true,
      handler () {
        this.buildLine()
      }
    }
  }
})

